export var AccessToken;
(function (AccessToken) {
    AccessToken["Access"] = "ACCESS_TOKEN";
    AccessToken["Refresh"] = "REFRESH_TOKEN";
    AccessToken["Temporary"] = "TEMPORARY_ACCESS_TOKEN";
})(AccessToken || (AccessToken = {}));
